import React from 'react';
import { Row, Col } from '@si-armes/dsfr-react';
import { useFormContext } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import PropTypes from 'prop-types';
import {
    isAssociation,
    STATUTS_METIER_ASSO,
} from '../../../../../../utils/Statuts.MetierAsso.constant';
import {
    PIECE_JOINTE_EXPLOITANT_TIR_FORAIN,
    PIECE_JOINTE_MUSEE_PIECES_JUSTIFICATIVES,
    PIECE_JOINTE_MUSEE_RAPPORT,
    PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_CERTIFICAT_MEDICAL,
    PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_PIECE_IDENTITE,
    PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_STATUS,
    PIECE_JOINTE_THEATRE_SOCIETE_PRODUCTION,
    PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ACTE_OFFICIEL_MINISTERE,
    PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_JUSTIFICATIF_REPRESENTANT_LEGAL,
    PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ETUDE_SURETE,
    PIECE_JOINTE_ASSOCIATION_FEDERATION_DECLARATION_COMPLEMENTAIRE,
} from '../../../../../../constants/metierAssociation.constants';

const InformationsDetenteursMetiersPersonnesMorales = ({ sousStatut }) => {
    const { register, formState, watch } = useFormContext();

    // SIAR-6341 : les pièces spécifiques Catégorie C (statuts, pièce identité,
    // certificat médical) ne s'affichent que pour une demande Catégorie C.
    const isCategorieC = watch('isCategorieC') === true;

    const isForain = sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_FORAIN;
    const isTheatresSocieteProduction =
        sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_PROD_ET_THEATRES;
    const isMusees = sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_MUSEES;
    const isNuisiblesParcsZoologiquesEssaisIndustriels =
        (sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_NUISIBLES ||
            sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_PARCS_ZOOLOGIQUES ||
            sousStatut === STATUTS_METIER_ASSO.METIER_MORALE_ESSAIS_INDUSTRIELS) &&
        isCategorieC;

    const isFFTIR = [STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR].includes(sousStatut);

    const isAssociationAvecFederationAutreQueFFTIR =
        isAssociation(sousStatut) &&
        sousStatut !== STATUTS_METIER_ASSO.ASSOCIATION_MORALE_NON_AFFILIE &&
        sousStatut !== STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR;

    return (
        <>
            {/* Exploitant tir forain */}
            {isForain && (
                <>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Déclaration précisant le nombre et la nature des armes mises en service au moyen de leurs marques, modèles, numéros et calibres prévue à l’article R.312-5 5°"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_EXPLOITANT_TIR_FORAIN}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_EXPLOITANT_TIR_FORAIN
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir une déclaration précisant le nombre et la
                                    nature des armes mises en service au moyen de leurs marques,
                                    modèles, numéros et calibres prévue à l’article R. 312-5 5°
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {/* Theatre */}
            {isTheatresSocieteProduction && (
                <>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Déclaration signée attestant que les armes détenues, désignées par leurs marques, modèles, numéros de série et calibres, ont été rendues inaptes au tir des munitions à balle ou à grenaille"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_THEATRE_SOCIETE_PRODUCTION}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_THEATRE_SOCIETE_PRODUCTION
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir une déclaration signée attestant que les armes
                                    détenues, désignées par leurs marques, modèles, numéros de série
                                    et calibres, ont été rendues inaptes au tir des munitions à
                                    balle ou à grenaille
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {/* Musees */}
            {isMusees && (
                <>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Rapport sur les moyens de protection contre le vol ou
                                            les intrusions et sur les modalités de conservation du
                                            matériel"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_MUSEE_RAPPORT}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[PIECE_JOINTE_MUSEE_RAPPORT]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir un rapport sur les moyens de protection contre
                                    le vol ou les intrusions et sur les modalités de conservation du
                                    matériel
                                </span>
                            </div>
                        </Col>
                    </Row>

                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    multiple
                                    label="Pièces justificatives de l’identité et de la qualité des représentants, de leur siège et de leur activité"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_MUSEE_PIECES_JUSTIFICATIVES}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_MUSEE_PIECES_JUSTIFICATIVES
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir les pièces justificatives de l’identité et de
                                    la qualité des représentants, de leur siège et de leur activité
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {/*  effaroucheurs, parcs zoologiques, régulateurs des nuisibles et essais industriels */}
            {isNuisiblesParcsZoologiquesEssaisIndustriels && (
                <>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Copie des statuts de la personne morale"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_STATUS}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_STATUS
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir une copie des statuts de la personne morale
                                </span>
                            </div>
                        </Col>
                    </Row>

                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    multiple
                                    label="Copie de la pièce justificative de l’identité du représentant légal en cours de validité"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_PIECE_IDENTITE}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_PIECE_IDENTITE
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir une copie de la pièce justificative de
                                    l’identité du représentant légal en cours de validité
                                </span>
                            </div>
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    multiple
                                    label="Certificat médical datant de moins d’un mois attestant que l’état de santé physique et psychique du représentant légal n’est pas incompatible avec la détention d’armes"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_CERTIFICAT_MEDICAL}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_CERTIFICAT_MEDICAL
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Veuillez fournir un certificat médical datant de moins d’un mois
                                    attestant que l’état de santé physique et psychique du
                                    représentant légal n’est pas incompatible avec la détention
                                    d’armes
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {/* Personnes morales : FFTIR uniquement */}
            {isFFTIR && (
                <>
                    {/* Acte officiel de délégation accordée par le ministère chargé des sports */}
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Acte officiel de délégation accordée par le ministère chargé des sports"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ACTE_OFFICIEL_MINISTERE}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ACTE_OFFICIEL_MINISTERE
                                        ]
                                    }
                                    required
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Pièce justificative du mandat légal du responsable légal */}
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Pièce justificative du mandat légal du responsable légal"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_JUSTIFICATIF_REPRESENTANT_LEGAL}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_JUSTIFICATIF_REPRESENTANT_LEGAL
                                        ]
                                    }
                                    required
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Étude de sûreté décrivant les mesures prévues à l’article R.314-8 */}
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Étude de sûreté décrivant les mesures prévues à l’article R.314-8"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ETUDE_SURETE}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ETUDE_SURETE
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Les armes de catégories A et B doivent être conservées dans des
                                    coffres-forts ou chambres fortes scellées ou dans des resserres
                                    sécurisées. Les armes de catégorie C doivent être fixée par
                                    câble ou chaîne ou système de sécurité équivalent. Les munitions
                                    doivent être conservées dans des conditions empêchant tout accès
                                    libre. L’étude doit préciser les personnes autorisées à accéder
                                    aux armes et les modalités de contrôle
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {/* Déclaration complémentaire */}
            {isAssociationAvecFederationAutreQueFFTIR && (
                <>
                    <Row gutters>
                        <Col lg={12}>
                            <div className="margin-bottom-md">
                                <InputFiles
                                    label="Déclaration complémentaire"
                                    {...register(
                                        `pieceJointes.${PIECE_JOINTE_ASSOCIATION_FEDERATION_DECLARATION_COMPLEMENTAIRE}.fichiers`,
                                        {
                                            required: 'Ce champ est obligatoire',
                                        },
                                    )}
                                    error={
                                        formState.errors?.pieceJointes?.[
                                            PIECE_JOINTE_ASSOCIATION_FEDERATION_DECLARATION_COMPLEMENTAIRE
                                        ]
                                    }
                                    required
                                />
                                <span className="fr-hint-text">
                                    Le document doit préciser :
                                    <ul>
                                        <li>
                                            la date de décision portant agrément ou autorisation de
                                            l’autorité de tutelle
                                        </li>
                                        <li>
                                            la ou les spécialités de tir (carabine, pistolet, etc.)
                                        </li>
                                        <li>le nombre de membres inscrits</li>
                                    </ul>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

InformationsDetenteursMetiersPersonnesMorales.propTypes = {
    sousStatut: PropTypes.string.isRequired,
};

export default InformationsDetenteursMetiersPersonnesMorales;
